<div class="header">

  <div class="subheader">

    <span class="material-symbols-outlined" style="font-size:30px">
      campaign
    </span>

    <span id="text">Announcements</span>
  </div>

  <div class="content">

    <span id="topcontent">Top Learners </span>

    <span id="subcontent">Courses Completed</span>

  </div>

  <div class="rowdata">

    <div class="details" *ngFor="let item of data?.slice(0,4);">

      <img
        src="https://img.freepik.com/free-photo/indoor-shot-beautiful-happy-african-american-woman-smiling-cheerfully-keeping-her-arms-folded-relaxing-indoors-after-morning-lectures-university_273609-1270.jpg"
        alt="" srcset="">

      <div class="detailtext">

        <span>{{item.employeeName}}</span>

      </div>

      <div id="count">{{item.count}}</div>

    </div>
  </div>
</div>